import styled from "styled-components";

export const MainContentContainer = styled.div`
  display: flex;
  flex-direction: column;
`;
